/* eslint-disable react/prop-types */
import React from "react";

export default function Harita2(props) {
  return (
    <div className={`col-lg-${props.colNumber}`}>
      <div id="map">
        <iframe
          src={
            props.embed === undefined
              ? "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1671!2d30.5213153!3d39.7685384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cc1603bc679897%3A0x84670b9962a6990!2sRBA%20Gayrimenkul!5e0!3m2!1str!2str!4v1642869952544!5m2!1str!2str"
              : props.embed
          }
          width="100%"
          height="500px"
          style={{
            border: "0",
            borderRadius: "10px",
            boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.15)",
          }}
          allowFullScreen=""
        ></iframe>
      </div>
    </div>
  );
}